import { z } from 'zod';
import { provincesEnum } from './payor';

export const eobSchema = z.object({
  id: z.string(),
  code: z.string(),
  description: z.string(),
  actionType: z.string().nullable(),
  actionDescription: z.string().nullable(),
  reviewRequired: z.boolean(),
  province: provincesEnum,
});
